import { useLazyQuery } from '@apollo/client';
import { SearchInput, SearchUserAccountResult } from '@bechtel/sr-types';
import { SEARCH_USER_ACCOUNTS } from '~/gql';

export function useSearchUserAccounts(fetchFromNetwork?: boolean) {
  const response = useLazyQuery<
    { searchUserAccounts: SearchUserAccountResult },
    {
      searchInput: SearchInput;
    }
  >(
    SEARCH_USER_ACCOUNTS,
    fetchFromNetwork
      ? {
          notifyOnNetworkStatusChange: true,
          fetchPolicy: 'network-only',
          nextFetchPolicy: 'cache-first',
        }
      : {
          notifyOnNetworkStatusChange: true,
          nextFetchPolicy: 'cache-first',
        }
  );
  return response;
}
